const READ_ONLY_MODE_LOCKED_EVENT = 'read-only-mode-locked';

export {READ_ONLY_MODE_LOCKED_EVENT};
